import React from 'react';
import { Box } from '@mui/material';
import PageTitle from '../components/PageTitle';
import AvailableClientResults from './components/AvailableClientResults/AvailableClientResults';
import AvailablePersonalResults from './components/AvailablePersonalResults/AvailablePersonalResults';
import './HistoricalResults.scss';
const HistoricalResults = () => {
  return (
    <>
      <PageTitle pageTitle="Online Results" />
      <Box className="historicalResults">
        <Box className="ccNotification">
          <h1>Please note: For current Perth and Melbourne results please use our <a href="https://clientconnect.envirolab.com.au/">ClientConnect</a> portal.</h1>
        </Box>
        <AvailableClientResults />
        <AvailablePersonalResults />
      </Box>
    </>
  );
};

export default HistoricalResults;
